import { useQuery } from 'react-query';
import { feedbackService } from '../../../service/feedback.service';
import { FeedbackHistoryItem, FeedbackHistoryRawItem } from '../../models/feedback';

/**
 * Map raw API item → UI-friendly shape.
 */
const mapRawToHistoryItem = (raw: FeedbackHistoryRawItem): FeedbackHistoryItem => ({
  id: raw.id,
  content: raw.content,
  email: raw.email,
  deviceId: raw.deviceId,
  userId: raw.userId,
  createdAt: raw.createdAt,
  status: (raw.status?.toLowerCase() || 'pending') as FeedbackHistoryItem['status'],
  reply: raw.adminReply || undefined,
  imageUrls: raw.images?.map(img => img.fileUrl) || [],
});

export function useGetFeedbackHistory(
  params: { deviceId: string; userId?: number; page?: number; size?: number },
  enabled = true
) {
  const query = useQuery(
    ['feedback-history', params.deviceId, params.userId, params.page, params.size],
    () => feedbackService.getFeedbackHistory(params),
    {
      enabled,
      cacheTime: 5 * 60 * 1000,
      staleTime: 30 * 1000,
      select: res => {
        const rawItems = res?.data?.content || [];
        return {
          items: rawItems.map(mapRawToHistoryItem),
          total: res?.data?.totalElements ?? 0,
          totalPages: res?.data?.totalPages ?? 0,
        };
      },
    }
  );

  return {
    historyItems: query.data?.items || [],
    total: query.data?.total ?? 0,
    totalPages: query.data?.totalPages ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
